import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import ContactsPage from "@app/views/contactsPage";
import Head from "next/head";
import React from "react";
import {wrapper} from "@app/store";

const Contacts = () => {
    return (
        <>
            <Head>
                <title>Контакты </title>
            </Head>
            <ContactsPage/>
        </>
    )
};


export const getServerSideProps = wrapper.getServerSideProps(store => async (ctx) => {
    return {
        props: {
            ...(await serverSideTranslations(ctx.locale, ["common"])),
        }
    }
});

export default Contacts;
